// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.3.0",
    "short": "1cea632",
    "branch": "Detached: 1cea6323014f384c9a2e01f9d4efcdcda99caba3",
    "date": "2026-8-2"
};
/* eslint:enable */
